
/**
 * set cookie
 * name             -       cookie name
 * value            -       cookie value
 * expireDays       -       cookie expire time
 */
export function setCookie(name, value, exDays) {
    const d = new Date();
    const host = location.host;
    exDays = exDays || 7;
    d.setTime(d.getTime() + (exDays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;

    if (host.split('.').length === 1) {
        document.cookie = `${name}=${value}; ${expires}; path=/`
    } else {
        const domainParts = host.split('.');
        domainParts.shift();
        const domain = `.${domainParts.join('.')}`;
        document.cookie = `${name}=${value}; ${expires}; path=/; domain=${domain}`

        if (name == '_jk_user') {
            document.cookie = `${name}=${value}; ${expires}; path=/; domain=.jackery.com`
        }
    }
}

/**
 * get cookie value by name
 * name             -       cookie name
 */
export function getCookie(name) {
    let arr = null;
    const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
    if (document.cookie && (arr = document.cookie.match(reg))) {
        return unescape(arr[2])
    }
    return null
}

export function removeCookie(name) {
    setCookie(name, "", -1)
}